/**
 * Gift pricing form ↔ wire conversion.
 *
 * Two independent numbers, no split between them:
 *   * `priceCoins` — what the SENDER pays, in coins (entered and sent as coins);
 *   * `listenerEarningPaise` — what the LISTENER earns per gift, real money,
 *     entered in ₹ and sent as integer paise.
 */
import { paiseToRupees, rupeesToPaise } from '../../lib/money';

export interface GiftPricingForm {
  priceCoins: number;
  listenerEarningRupees: number;
}

export interface GiftPricingWire {
  priceCoins: number;
  listenerEarningPaise: number;
}

export function giftPricingFromRow(row: {
  priceCoins: number;
  listenerEarningPaise?: number | string | null;
}): GiftPricingForm {
  return {
    priceCoins: row.priceCoins,
    listenerEarningRupees: paiseToRupees(row.listenerEarningPaise ?? 0),
  };
}

export function giftPricingToWire(form: GiftPricingForm): GiftPricingWire {
  return {
    priceCoins: Math.trunc(form.priceCoins),
    listenerEarningPaise: Math.max(0, rupeesToPaise(form.listenerEarningRupees)),
  };
}

export function giftPricingError(form: GiftPricingForm): string | null {
  if (!Number.isInteger(form.priceCoins) || form.priceCoins < 1)
    return 'Price must be a whole number of coins ≥ 1';
  if (!Number.isFinite(form.listenerEarningRupees) || form.listenerEarningRupees < 0)
    return 'Listener earning must be ₹0 or more';
  return null;
}
